/**
 * Frontend runtime config.
 * API base URL is overridable at build time via REACT_APP_API_URL
 * (CRA inlines REACT_APP_* env vars). Defaults to the local backend.
 */
export const API_BASE_URL =
  process.env.REACT_APP_API_URL || 'http://localhost:3001';

// localStorage keys — namespaced to avoid collisions on shared origins.
export const TOKEN_KEY = 'aisafeplate.accessToken';
export const REFRESH_KEY = 'aisafeplate.refreshToken';
export const USER_KEY = 'aisafeplate.user';

// Window event the API client emits when auth is irrecoverably lost,
// so the AuthProvider can clear React state without a circular import.
export const LOGOUT_EVENT = 'aisafeplate:logout';
